/**
 *  指挥监控中心
 *  2018-4-13
 *  gao.kaizhi
 */
"use strict";
angular.module("commandMonitorModule", [
	"commandMonitorLeftModule",
	"commandMonitorRouterModule",
	"planCommandMonitorBasicManageModule",
	"planCommandMonitorServiceModule",
	"publicOpinionMgrZjModule",
	"planCommandMonitorOncePublicOpinionModule",
	"planCommandMonitorManuscriptAnalysisModule",
	"planCommandMonitorRegionalHotspotsModule",
	"mapSchedulingModule"
]).
controller("commandMonitorCtrl", [function() {
	
}]);